import type { TFormStep } from "@/components/forms"
import type { TActivityType } from "@/types"
import { AudienceStep } from "./AudienceStep"
import { DateTimeStep } from "./DateTimeStep"
import { NotifyStep } from "./NotifyStep"
import { PreviewStep } from "./PreviewStep"

export * from "./AudienceStep"
export * from "./DateTimeStep"
export * from "./PreviewStep"

export const scheduleSteps: Partial<Record<TActivityType, TFormStep[]>> = {
  coffee: [DateTimeStep, AudienceStep, PreviewStep],
  feedback: [DateTimeStep, AudienceStep, NotifyStep, PreviewStep],
  onboarding: [DateTimeStep, AudienceStep, NotifyStep, PreviewStep],
  other: [DateTimeStep, AudienceStep, PreviewStep],
  pulse: [DateTimeStep, AudienceStep, NotifyStep, PreviewStep],
  survey: [DateTimeStep, AudienceStep, NotifyStep, PreviewStep],
}
